module.exports = __webpack_public_path__ + "img/copy.6d90ff4d.svg";